import { useMutation } from 'react-query'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ManagementAddNewLoanValidateAddOld } from 'services/loans/manager'
import posthog from 'posthog-js'
import useFinishFlow, { FLOWS } from 'utilities/navigation/flow'

export default function useSetFinalOld() {
    const finishFlow = useFinishFlow(FLOWS.pastLoan)
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IIManagementAddOldPayload) => {
            return ManagementAddNewLoanValidateAddOld(payload)
        },
        onSuccess: (response, variables) => {
            posthog.capture('old_loan_registered', {
                fund_id: (state as any)?.payload?.moneyPool,
            })
            toast.success('وام با موفقیت ثبت گردید')
            finishFlow(`/fund/${state?.payload?.moneyPool}`, {
                poolShipId: state?.payload?.poolShip,
            })
        },
        onError: (error: any) => {
            posthog.capture('old_loan_register_failed', {
                step: 'final',
                status: error?.response?.status,
                fund_id: (state as any)?.payload?.moneyPool,
            })
            toast.error('مشکلی رخ داده!')
        },
    })

    return { isLoading, mutate }
}
